import Backbone from "backbone";
import _ from "underscore";
import {date, availabilityUtils} from "utils";
import FlythroughEngine from "utils/flythrough";
import {Size, microfishify} from "utils/img";
import {modal, galleryModal, contactFormModal} from "utils/modal";
import {customEvent} from "utils/events";

import template from "./template.html";

let DetailsView = Backbone.View.extend({
    template,
    id: "fp_view_detailed",
    className: "fp-panel",
    attributes: {
        role: "tabpanel"
    },
    events: {
        "click [role=tab]": "tabSelect",
        "click .thumbs-3d > .thumb": "handleThumb",
        "click .fp-image": "fpImageModal",
        "click .gallery-img": "fpGalleryModal",
        "click .app-back-button": "backButton",
        "click .application-link > a": "tryFireGoogleAnalyticsApplyEvent",
        "click .notify-me": "openNotifyMeModal"
    },
    initialize: function(options) {
        let opts = _.defaults({}, options, {
            floorPlan: null,
            unit: null,
            alwaysShowWaitList: false,
            applyString: "Apply Now",
            applyUnitString: "Apply for this unit",
            descriptionTitle: "Description",
            useApplyUnitDescription: false,
            applyUnitDescription: "For specific pricing please reserve this home and choose your lease term today!",
            useContactFormButton: false,
            useApplicationLinkNewTab: true
        });
        this.options = opts;

        this.imageSize = new Size(1200, 800);

        this.floorPlan = opts.floorPlan;
        this.unit = opts.unit;
    },
    render: function() {
        this.$el.empty();

        let {floorPlan, unit} = this;

        if (!floorPlan) {
            return this;
        }

        let bed = floorPlan.get("bed");
        let bedStr = bed ? `${bed} Bed` : floorPlan.get("display_bed");

        let photos = this.getImages(floorPlan);
        let amenities = floorPlan.get("amenities");
        let selectUnits = floorPlan.get("amenities_in_select_units");
        let has3D = floorPlan.has3D();
        let hasGalleryTour = floorPlan.hasGalleryTour();
        let tour = floorPlan.getTour();
        let panorama = floorPlan.hasPanorama();
        let galleryTour = floorPlan.getGalleryTour();
        let area = floorPlan.getArea();
        
        let community = floorPlan.get("community");
        let floor = "";
        let address = community.address;
        let description = floorPlan.get("description");

        let hasMap = community.map && community.map.length > 0;
        let hideUnitNumbers = floorPlan.getHideUnitNumbers();

        let hideUnitAvailability = floorPlan.getHideUnitAvailability();
        let visibleUnit = unit && !hideUnitAvailability;

        let rent = floorPlan.get("rent");
        let deposit = floorPlan.get("deposit");
        let customLink = floorPlan.get("custom_link");
        let customLinkText = floorPlan.get("custom_link_text");
        let customMobileLink = floorPlan.get("custom_mobile_link");
        let customMobileLinkText = floorPlan.get("custom_mobile_link_text");

        let unitAmenities = [];

        let unitPromo = "";
        let applicationUnitLinkHTML = "";

        let applyString = this.options.applyString;
        let applyUnitString = this.options.applyUnitString;
        let useApplyUnitDescription = this.options.useApplyUnitDescription;
        let applyUnitDescription = this.options.applyUnitDescription;
        let descriptionTitle = this.options.descriptionTitle;
        let apartmentType = this.options.apartmentType;
        let apartmentTypeLong = this.options.apartmentTypeLong;
        let useApplicationLinkNewTab = this.options.useApplicationLinkNewTab;
        const useContactFormButton = this.options.useContactFormButton;

        let applicationLinkHTML = floorPlan.availabilityHTML(
            applyString,
            useApplicationLinkNewTab,
            useContactFormButton);

        let availableDate = "";
        if (visibleUnit) {
            let alt = new Date();
            alt.setHours(0, 0, 0, 0);

            let avail = unit.get("available_date");

            if (avail > alt) {
                availableDate = date.format(avail);
            } else {
                availableDate = date.format(alt);
            }

            address = unit.get("address");

            floor = unit.get("floor");

            unitPromo = unit.promo();

            let appLink = unit.get("availability_link");
            if (appLink) {
                if (this.options.alwaysShowWaitList) {
                    applicationUnitLinkHTML = unit.availabilityHTML(
                        applyUnitString,
                        useApplicationLinkNewTab);
                } else {
                    applicationLinkHTML = unit.availabilityHTML(
                        applyString,
                        useApplicationLinkNewTab);
                }
            }

            let dep = unit.get("deposit");
            if (dep) {
                deposit = dep;
            }
            let unitRent = unit.get("rent");
            if (unitRent) {
                rent = unit.get("rent");
            }

            let amen = unit.get("vendor_amenities");
            if (amen.length) {
                unitAmenities = amen;
            }

            let unitDescription = unit.get("description");
            if (unitDescription) {
                description = unitDescription;
            }
        }

        let context = {
            applyString,
            applyUnitString,
            useApplyUnitDescription,
            applyUnitDescription,
            floor,
            floorPlan,
            unit,
            bedStr,
            photos,
            amenities,
            selectUnits,
            has3D,
            hasGalleryTour,
            tour,
            panorama,
            galleryTour,
            area,
            availableDate,
            address,
            community,
            hideUnitNumbers,
            visibleUnit,
            deposit,
            rent,
            unitAmenities,
            unitPromo,
            hasMap,
            customLink,
            customLinkText,
            customMobileLink,
            customMobileLinkText,
            descriptionTitle,
            description,
            apartmentType,
            apartmentTypeLong,
            applicationLinkHTML,
            applicationUnitLinkHTML
        };

        this.$el.html(this.template(context));

        if (floorPlan.hasFlythrough()) {
            let flythrough = floorPlan.get("flythrough");
            this.engine = new FlythroughEngine({
                frameHeight: flythrough.height,
                frameWidth: flythrough.width,
                frameImageHeight: flythrough.image_height,
                frameImageWidth: flythrough.image_width,
                image: flythrough.image
            });
            this.setUpFlythrough(flythrough);

            this.$el.find(".canvas-container").append(this.engine.getCanvas());

            let doc = document.createDocumentFragment();
            for (let i = 0; i < this.numThumbs; i++) {
                let elem = document.createElement("a");
                $(elem).css({
                    backgroundImage: `url(${flythrough.thumbnail_image})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: `0 -${i * flythrough.thumbnail_height}px`,
                    width: flythrough.thumbnail_width,
                    height: flythrough.thumbnail_height
                }).addClass("thumb");
                elem.setAttribute(
                    "data-frame",
                    i * (flythrough.image_width / flythrough.width)
                );
                doc.appendChild(elem);
            }
            this.$el.find(".thumbs-3d").append(doc);
            this.engine.render();
        }
        
        if (customLink && customMobileLink) {
            this.updateCustomLinkButtonsVisibility();
        }
        let loadEvent = customEvent("fp-details-load");
        window.dispatchEvent(loadEvent);
        return this;
    },
    updateCustomLinkButtonsVisibility: function() {
        const isDesktop = this.renderSize == "lg";

        this.$el.find(".fp-tab-custom-link").toggleClass("hide", !isDesktop);
        this.$el.find(".fp-tab-custom-mobile-link").toggleClass("hide", isDesktop);
    },
    openNotifyMeModal: function(e) {
        e.preventDefault();

        contactFormModal(this.floorPlan, this.unit);
    },
    tabSelect: function(e) {
        e.preventDefault();
        let elem = e.currentTarget;
        let href = elem.getAttribute("href");

        switch (href) {
            case "#settings":
                this.collection.trigger("nav", "map", [this.floorPlan, this.unit]);
                this.collection.trigger("nav:map", this.floorPlan, this.unit);
                break;
            case "#fp_threed":
                const tour = this.floorPlan.getTour();
                if (tour) {
                    e.preventDefault();
                    break;
                }
            default:
                this.$el.find(elem).tab("show");
        }
    },
    getImages: function(fp) {
        let s = this.imageSize.copy();
        s.resizeX(200);
        return _.map(fp.getPhotos(), function(img) {
            let image = _.clone(img);
            image.full = img.image;
            image.image = microfishify(img.image, s);
            return image;
        });
    },
    setUpFlythrough: function(fly) {
        this.currentFrame = 0;
        this.numFrames = fly.image_width / fly.width * fly.image_height / fly.height;
        this.numThumbs = fly.thumbnail_image_height / fly.thumbnail_height;
    },
    handleThumb: function(e) {
        let elem = e.currentTarget;
        let frame = parseInt(elem.getAttribute("data-frame"), 10);
        this.engine.moveTo(frame);
    },
    fpImageModal: function(e) {
        e.preventDefault();
        let elem = e.currentTarget.querySelector("img");
        if (elem) {
            modal(elem.src, this.floorPlan.get("name"));
        }
    },
    fpGalleryModal: function(e) {
        e.preventDefault();
        let elem = e.currentTarget;
        galleryModal(
            this.getImages(this.floorPlan),
            parseInt(elem.getAttribute("data-gallery-index"), 10),
            this.floorPlan.get("name")
        );
    },
    backButton: function(e) {
        e.preventDefault();
        let fp = this.floorPlan;
        let showUnits = fp && fp.get("units").length && !fp.getHideUnitAvailability();
        let tab = showUnits ? "#fp_view_units" : "#fp_view_start";
        this.trigger("tab", tab);
    },
    tryFireGoogleAnalyticsApplyEvent: function(evt) {
        try {
            if (typeof gtag === "function") {
                gtag("event", "click", {
                    "event_category": "Apply Now"
                });
            } else if (typeof ga === "function") {
                ga("send", "event", "Apply Now", "click");
            }
        } catch (e) {
            // Report error, but don't crash...
            console.error(e);
        }
    }
});

export {DetailsView};
